import Sidebar from "../../components/Sidebar/Sidebar";
import { Topbar } from "../../components/Topbar/Topbar";
import "./AddStudentsPage.scss";
import Button from "../../components/Button/Button";
import { SimpleStudent } from "../../types";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TableColumn } from "react-data-table-component/dist/src/DataTable/types";
import Table from "../../components/Table/Table";
import DragAndDropFileUploader from "../../components/DragAndDropFileUploader/DragAndDropFileUploader";
import axiosClient from "../../axiosClient";
import toast from "react-hot-toast";

const AddStudentsPage = (props: any) => {
  // drag state
  const [students, setStudents] = useState<SimpleStudent[]>([]);
  const navigate = useNavigate();

  const columns: TableColumn<any>[] = [
    {
      id: "firstName",
      name: "First Name",
      selector: (row: any) => row.firstName,
    },
    {
      id: "surname",
      name: "Surname",
      selector: (row: any) => row.surname,
    },
    {
      id: "class",
      name: "Class",
      selector: (row: any) => row.class,
    },
    {
      id: "year",
      name: "Year",
      selector: (row: any) => row.year,
    },
  ];

  const onCancelButtonClick = () => {
    setStudents([]);
  };

  const onConfirmButtonClick = async () => {
    try {
      await axiosClient.post("/students", students);
      toast.success("Success!");
      navigate("/dashboard");
    } catch (err) {
      toast.error("Error occurred when persiting students. Please contact support.");
      console.error(err);
      navigate("/");
    }
  };

  return (
    <div className="page-wrapper" id="AddStudentsPage">
      <Sidebar />
      <div className="internal-page-wrapper">
        <Topbar title="Add Students" />
        <main>
          <div className="white-box">
            {students.length > 0 ? (
              <>
                <div id="review-students-header-wrapper">
                  <h2>Review students</h2>
                  <div id="review-students-button-wrapper">
                    <Button
                      text="Cancel"
                      type="inverse"
                      onClick={onCancelButtonClick}
                    />
                    <Button text="Confirm" onClick={onConfirmButtonClick} />
                  </div>
                </div>

                <p>
                  Please review the students to be added, and if happy, please
                  click on the 'Confirm' button. If you are unhappy, please
                  click on 'Cancel' to try again.
                </p>

                <Table columns={columns} data={students} />
              </>
            ) : (
              <>
                <h2>Students csv file upload</h2>
                <p>
                  Please upload a csv file containing all students to be
                  enrolled in your school/academy.
                </p>
                <p>
                  Csv files must contain the following columns in the following
                  order <strong>(and match them exacty)</strong>:{" "}
                  <code>First name, Surname, Class, Year</code>
                </p>
                <p>
                  Please download this template csv file and then update to
                  include all your students.
                </p>
                <Button text="Download template.csv" type="inverse" />

                <DragAndDropFileUploader
                  accept=".csv"
                  setData={setStudents}
                  expectedColumnTitles={[
                    "First Name",
                    "Surname",
                    "Class",
                    "Year",
                  ]}
                />
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddStudentsPage;
